import { render, staticRenderFns } from "./PriceListUpdate.vue?vue&type=template&id=7be2a5c4&scoped=true&"
import script from "./PriceListUpdate.vue?vue&type=script&lang=js&"
export * from "./PriceListUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PriceListUpdate.vue?vue&type=style&index=0&id=7be2a5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be2a5c4",
  null
  
)

export default component.exports